import {t} from '@eitje/bridge'
import {addNotif} from './notification_context'

export const notify = ({duration = 3.5, type, ...rest}) => {
	const params = {duration, ...rest}
	switch (type) {
		case 'success':
			return successNotif(params)
		case 'error':
			return errorNotif(params)
		case 'info':
			return infoNotif(params)
		default:
			return addNotif(params)
	}
}

export const infoNotif = ({duration = 5, ...rest}) => {
	return addNotif({
		duration,
		baseColor: 'blue',
		...rest,
	})
}

export const errorNotif = ({title = t('oops'), duration = 5, ...rest}) => {
	return addNotif({
		title,
		baseColor: 'red',
		duration,
		...rest,
	})
}

export const errNotif = (title, content, duration = 5) => {
	return addNotif({
		title,
		baseColor: 'red',
		content,
		duration,
	})
}

export const successNotif = ({title = t('success'), duration = 3, ...rest}) => {
	return addNotif({
		title,
		baseColor: 'green',
		duration,
		...rest,
	})
}

export const success = (title = t('saved'), duration = 1) => {
	return addNotif({
		title,
		baseColor: 'green',
		icon: 'checked',
		small: true,
		position: 'center',
		duration,
	})
}

export const unknownError = () => {
	return errNotif(t('oops'), t('unknownError'))
}

// LEGACY

export const openNotif = (title, type = 'info', content = '') => {
	notify({
		type,
		title,
		content,
		duration: 3.5,
	})
}
